(function ($, Drupal, once) {
  "use strict";

  /*----------------------------------------
   Stop preload animations
   https://css-tricks.com/transitions-only-after-page-load/
  ----------------------------------------*/

  $(document).ready(function () {
    $("body").removeClass("preload");
  });

/**** Para nuevo header, comentado de momento ****/
  /*$(document).ready(function () {
    $('[data-toggle="offcanvas"]').on('click', function () {
      $('.offcanvas-collapse').toggleClass('open');
      $('.offcanvas-backdrop').toggleClass('show');
      $('body').toggleClass('removeScroll');
    });
    $('.btn-close').on('click', function () {
      $('.offcanvas-collapse').removeClass('open');
      $('.offcanvas-backdrop').removeClass('show');
      $('body').removeClass('removeScroll');
    });
  }); */


  $(function () {
    var path = window.location.pathname;

    if (path === "/buscar/contenido") {
      $("body").addClass("terms--diners terms--personas");
    }
    if (path == "/descarga-app-blu-personas") {
      $("body").addClass("terms--diners terms--personas");
    }
    if (path == "/descarga-app-blu-benefits") {
      $("body").addClass("terms--diners terms--personas");
    }
    if (path == "/descarga-payclubwallet") {
      $("body").addClass("terms--diners terms--personas");
    }
  });

  $(".header__wrapper").addClass("is-visible");
  var header = $(".header__wrapper");
  header.removeClass("is-invisible", "is-visible").addClass("is-sticky");

  Drupal.behaviors.example = {
    attach: function (context, settings) {
      $(".footer-accordion-menu .sf-accordion-toggle.sf-style-black").css(
        "display",
        "none"
      );

      $("#superfish-primary-nav-visible-accordion")
        .addClass("sf-expanded")
        .removeClass("sf-hidden");
      $("#btn-menu-trigger").click(function () {
        $("#superfish-primary-nav-visible-accordion")
          .addClass("sf-expanded")
          .removeClass("sf-hidden");
        $(this).toggleClass("clicked");
        $("body").toggleClass("removeScroll");
        $("#menu__responsive").toggleClass("menu-visible");
      });

      $(".menu__responsive .button__close").click(function () {
        $("#menu__responsive").removeClass("menu-visible");
      });
      $(
        "#block-barebones-enhanced-main-menu li.menu-item__soluciones-para-ti button"
      ).click(function () {
        $(this).toggleClass("clicked");
        $("body").addClass("removeScroll");
        $(".menu__hidden.menu__diners-para-ti").addClass("menu--visible");
        $(".menu__hidden.menu__diners-experiencias").removeClass(
          "menu--visible"
        );
        $(".menu__hidden.menu__menu__diners-vision").removeClass(
          "menu--visible"
        );
        $(".menu__hidden.menu__diners-empresas").removeClass("menu--visible");
      });

      /*** Servicios Empresas */
      $(
        "#block-barebones-enhanced-main-menu li.menu-item__soluciones-empresas button"
      ).click(function () {
        $(this).toggleClass("clicked");
        $("body").addClass("removeScroll");
        $(".menu__hidden.menu__diners-empresas").addClass("menu--visible");
      });

      $(
        "#block-barebones-enhanced-main-menu li.menu-item:nth-child(2) button"
      ).click(function () {
        $(this).toggleClass("clicked");
        $("body").addClass("removeScroll");
        $(".menu__hidden.menu__diners-para-ti").removeClass("menu--visible");
        $(".menu__hidden.menu__diners-experiencias").removeClass(
          "menu--visible"
        );
        $(".menu__hidden.menu__menu__diners-vision").removeClass(
          "menu--visible"
        );
        $(".menu__hidden.menu__diners-empresas").addClass("menu--visible");
      });

      $(
        "#block-barebones-enhanced-main-menu li.menu-item:nth-child(5) button"
      ).click(function () {
        $(this).toggleClass("clicked");
        $("body").addClass("removeScroll");
        $(".menu__hidden.menu__diners-para-ti").removeClass("menu--visible");
        $(".menu__hidden.menu__diners-empresas").removeClass("menu--visible");
        $(".menu__hidden.menu__menu__diners-vision").removeClass(
          "menu--visible"
        );
        $(".menu__hidden.menu__diners-experiencias").addClass("menu--visible");
      });

      $(
        "#block-barebones-enhanced-main-menu li.menu-item:nth-child(6) button"
      ).click(function () {
        $(this).toggleClass("clicked");
        $("body").addClass("removeScroll");
        $(".menu__hidden.menu__diners-para-ti").removeClass("menu--visible");
        $(".menu__hidden.menu__diners-empresas").removeClass("menu--visible");
        $(".menu__hidden.menu__diners-experiencias").removeClass(
          "menu--visible"
        );
        $(".menu__hidden.menu__diners-vision").addClass("menu--visible");
      });

      $("button.button__close").click(function () {
        $(".menu__hidden").removeClass("menu--visible");
        $("body").removeClass("removeScroll");
      });

      // Tabs for TITANIUM Cards
      $("#tab-titanium-visa").click(function () {
        $(this).addClass("active-tab");
        $("#tab-titanium-mastercard").removeClass("active-tab");
      });

      $("#tab-titanium-mastercard").click(function () {
        $(this).addClass("active-tab");
        $("#tab-titanium-visa").removeClass("active-tab");
      });

      // Tabs for Titanium Cards Comparator
      $("#button-cards-01").addClass("btn-active");
      $("#button-cards-01").click(function () {
        $(this).addClass("btn-active");
        $("#button-cards-02").removeClass("btn-active");
        $(".comparator__tab-content.comparator__tab-content--02").fadeOut(
          "fast"
        );
        $(".comparator__tab-content.comparator__tab-content--01").fadeIn(
          "slow"
        );
      });

      $("#button-cards-02").click(function () {
        $(this).addClass("btn-active");
        $("#button-cards-01").removeClass("btn-active");
        $(".comparator__tab-content.comparator__tab-content--01").fadeOut(
          "fast"
        );
        $(".comparator__tab-content.comparator__tab-content--02").fadeIn(
          "slow"
        );
      });

      //Poster for video homepage
      var videoposter =
        "/themes/contrib/barebones_enhanced/assets/images/bg-video-homepage.webp";
      $(".path-frontpage .hero__video video").attr("poster", videoposter);

      //Autoplay for Safari
      $(".media--type-video-autoplay video").attr("playsinline", "");
      $("video").attr("playsinline", "");

      $(".faqfield-anchor-list .faqfield-answer ").addClass(" closed-answer ");
      $(".faqfield-anchor-list .faqfield-question ").click(function () {
        $(this)
          .next()
          .toggleClass(" closed-answer ")
          .toggleClass(" open-answer ");
      });

      $("h1").each(function () {
        if ($(this).children().length == 0) {
          $(this).html(
            $(this).html().replace(/®/g, '<sup class="registered">®</sup>')
          );
        }
      });

      // Simulador de coste de deuda con min y max
      $(function () {
        $("#simulador__input").on("keyup", function () {
          var max = parseInt($(this).attr("max"));
          var min = parseInt($(this).attr("min"));
          if ($(this).val() > max) {
            $(this).val(max);
          } else if ($(this).val() < min) {
            $(this).val(min);
          }
        });
      });

      $("#simulador__input").on("keyup", function () {
        var zeroValue = 0;
        var oneThousand = 1000;
        var topCounter = 100000;
        var maxValue = 100000;
        var minValue = 1.24;
        var inputInitValue = $("#simulador__input").val();
        var inputValueCalc = $("#simulador__input").val() * 0.00124;
        var toFixedInputValue = inputValueCalc.toFixed(2);
        if (inputInitValue == 0) {
          $(".simulador__output-moneda").removeClass("hide-me");
          $("#simulador__output-value").text(zeroValue);
        }
        if (inputInitValue > 0 && inputInitValue < 1001) {
          $(".simulador__output-moneda").removeClass("hide-me");
          $("#simulador__output-value").text(minValue);
        }
        if (inputInitValue >= 1001 && inputInitValue <= 7000) {
          $(".simulador__output-moneda").removeClass("hide-me");
          $("#simulador__output-value").text(toFixedInputValue);
        }
        if (inputInitValue > 7000) {
          $(".simulador__output-moneda").removeClass("hide-me");
          $("#simulador__output-value").text("8.68");
        }
        if (inputInitValue > 100000) {
          $(".simulador__output-moneda").addClass("hide-me");
          $("#simulador__output-value").text("El monto máximo es de $100.000");
        }
      });

      /*** Simulador Cashback ***/
      $(".calculator-wrapper #form-item-input").on(
        "keyup touchend",
        function () {
          var inputInitialValue = $("#form-item-input").val();
          var inputValueCalculate = $("#form-item-input").val() * 0.01;
          var resultValue = inputValueCalculate.toFixed(2);
          if (inputInitialValue > 0) {
            $("#form-item-output").text(resultValue);
          }
          $("#form-item-output").addClass("heyMe");
        }
      );

      /*** Show/Hide Discover Barcelona Webforms ***/
      $("#btn-hazte-socio-diners").click(function () {
        $(this).addClass("btn-active");
        $("#btn-solicita-tarjeta-discover").removeClass("btn-active");
        $(
          "#webform-submission-discover-bsc-prospeccion-paragraph-6155-add-form"
        ).fadeIn("slow");
        $(
          "#webform-submission-adquisicion-discover-bsc-socios-paragraph-6154-add-form"
        ).fadeOut("fast");
      });
      $("#btn-solicita-tarjeta-discover").click(function () {
        $(this).addClass("btn-active");
        $("#btn-hazte-socio-diners").removeClass("btn-active");
        $(
          "#webform-submission-adquisicion-discover-bsc-socios-paragraph-6154-add-form"
        ).fadeIn("slow");
        $(
          "#webform-submission-discover-bsc-prospeccion-paragraph-6155-add-form"
        ).fadeOut("fast");
      });

      $("#btn-solicita-tarjeta").click(function () {
        $(this).addClass("btn-active");
        $("#btn-hazte-socio").removeClass("active");
        $(
          "#webform-submission-adquisicion-discover-bsc-socios-paragraph-6172-add-form"
        ).fadeIn("slow");
        $(
          "#webform-submission-discover-bsc-prospeccion-paragraph-6173-add-form"
        ).fadeOut("fast");
      });

      $("#btn-hazte-socio").click(function () {
        $(this).addClass("btn-active");
        $("#btn-solicita-tarjeta").removeClass("active");
        $(
          "#webform-submission-adquisicion-discover-bsc-socios-paragraph-6172-add-form"
        ).fadeOut("fast");
        $(
          "#webform-submission-discover-bsc-prospeccion-paragraph-6173-add-form"
        ).fadeIn("slow");
      });

      /**** PLay Audio ***/
      var playing = false;
      $("#audio-button").click(function () {
        $(this).toggleClass("down");

        if (playing == false) {
          document.getElementById("player").play();
          playing = true;
          $(this).html(
            '<span class="button-icon button-icon--play">&nbsp;</span>Parar canción'
          );
        } else {
          document.getElementById("player").pause();
          playing = false;
          $(this).html(
            '<span class="button-icon button-icon--pause">&nbsp;</span>Activar canción'
          );
        }
      });

      /*** Add class if input is checked ***/
      $(".landing-discover-barcelona input:checkbox").change(function () {
        if ($(this).is(":checked")) {
          $(this).parent(".form-type-checkbox").addClass("form-type-selected");
          $(this)
            .parent(".form-type-checkbox")
            .find(".option")
            .addClass("selected");
        } else {
          $(this)
            .parent(".form-type-checkbox")
            .removeClass("form-type-selected");
          $(this)
            .parent(".form-type-checkbox")
            .find(".option")
            .removeClass("selected");
        }
      });

      /*** Show/Hide Membresias ***/
      $("#button-membresias").click(function () {
        $(".section-membresias").slideDown("slow").toggleClass("sho-me");
        $(".paragraph__membresias").addClass("show-membresias");
      });

      $("#button-close-membresias").click(function () {
        $(this).toggleClass("active");
        $(this)
          .parents(".paragraph__membresias")
          .addClass("hide-membresias")
          .removeClass("show-membresias");
        $(this)
          .parents(".section-membresias")
          .slideUp("slow")
          .removeClass("sho-me");
      });

      /*** CHange dots for comma in simuladores ***/
      $(
        ".webform-submission-simulador-diferido-preferente-form .form-type-item"
      ).html("$");

      /*** Slick carrusel init ***/
      $(document).ready(function () {
        $(".slick-wrapper").slick();
      });

      function sticky_relocate() {
        var window_top = $(window).scrollTop();
        var $pillsContainer = $(".pills-container");

        if ($pillsContainer.length) {
          var div_top = $pillsContainer.offset().top - 100;

          if (window_top > div_top) {
            $("#pills-tab").addClass("stickTabs");
          } else {
            $("#pills-tab").removeClass("stickTabs");
          }
        }
      }

      $(function () {
        $(window).scroll(sticky_relocate);
        sticky_relocate();
      });

      /*** Move Recomendador from outside main content to a paragraph section inside Main Content ***/
      $(document).ready(function () {
        $("#block-views-block-recomendador-block-1").insertAfter(
          "#explora-mas-servicios .layout__region"
        );
      });

      /*** Sticky for Destinados a crear ***/
      $(window).scroll(function () {
        if ($(window).scrollTop() > 980) {
          $(".section__nav").addClass("stickSection");
        } else {
          $(".section__nav").removeClass("stickSection");
          $(".section__nav li").removeClass("active");
        }
      });

      $(".inner-nav-item").click(function () {
        $(".inner-nav-item").removeClass("active");
        $(this).addClass("active");
      });
    },
  };

  /*** Menu footer ****/
  $(document).ready(function () {
    $("#superfish-primary-nav-visible--2-toggle").css("display", "none");
    $("#superfish-primary-nav-visible--2-accordion")
      .addClass("sf-expanded")
      .removeClass("sf-hidden");
  });
  /****   ****/

  $(document).ready(function () {
    $(".beneficio__title").click(function () {
      $(this).toggleClass("clicked");
      $(this).next().slideToggle();
    });
  });

  $(document).ready(function () {
    $("#contact-trigger").click(function () {
      $(this).toggleClass("hide");
      $(".contact-buttons-wrapper").fadeIn();
    });
    $("#contact-close-button").click(function () {
      $(this).toggleClass("hide");
      $(".contact-buttons-wrapper").fadeOut("fast");
      $("#contact-trigger").removeClass("hide");
    });
  });

  $(document).ready(function () {
    $("#navidad-youtube-close").click(function () {
      $(".navidad-section__youtube-video").fadeOut();
    });
  });

  /*** Lounge  ***/
  $(window).scroll(function () {
    var sticky = $(".innner-navigation"),
      scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass("fixed");
    else sticky.removeClass("fixed");
  });

  /**** Beneficios ****/
  $(document).ready(function () {
    $(".accordion__header").click(function () {
      $(this).toggleClass("clicked");
      $(this).next().slideToggle();
    });
  });

  $(document).ready(function () {
    var $targetElement = $(".section__cards-comparator");
    if ($targetElement.length > 0) {
      var targetOffset = $targetElement.offset().top;
    }
  });

  /*** Print Searched Keyword ***/
  $(document).ready(function () {
    var inputSearchValue = $(
      "#views-exposed-form-search-content-page-1 input.form-text"
    ).val();
    if ($(".path-buscar").hasClass("search--active")) {
      $(".view-header").addClass("view-header--keyword");
      $(".search--keywords").addClass("active-field");
      $(".search--keywords").text('"' + inputSearchValue + '"');
    }
  });

  /**** Page Manual Blue Tabs ****/
  $(document).ready(function () {
    $(".page-manual-blu-ahorro #tab-web").click(function () {
      $(this).toggleClass("active");
      $(".tab__btn--app").removeClass("active");
      $(".section__content--web").fadeIn().addClass("section-active");
      $(".section__content--app").fadeOut().removeClass("section-active");
    });
    $(".page-manual-blu-ahorro #tab-app").click(function () {
      $(this).toggleClass("active");
      $(".tab__btn--web").removeClass("active");
      $(".section__content--app").fadeIn().addClass("section-active");
      $(".section__content--web").fadeOut().removeClass("section-active");
    });
  });

  /*** Ganadoras TITANIUM ***/

  $(document).ready(function () {
    $("#propositos-2023").click(function () {
      $(".section__propositos").fadeIn("slow");
      $(".section__propositos-2").fadeIn("slow");
      $(".section__latingrammys").fadeOut("fast");
      $(".section__uefa-champions").fadeOut("fast");
      $(this).addClass("active");
      $("#latin-grammys").removeClass("active");
      $("#uefa-champions-league").removeClass("active");
    });

    $("#latin-grammys").click(function () {
      $(".section__latingrammys").fadeIn("slow");
      $(".section__propositos").fadeOut("fast");
      $(".section__propositos-2").fadeOut("fast");
      $(".section__uefa-champions").fadeOut("fast");
      $(this).addClass("active");
      $("#propositos-2023").removeClass("active");
      $("#uefa-champions-league").removeClass("active");
    });

    $("#uefa-champions-league").click(function () {
      $(".section__uefa-champions").fadeIn("slow");
      $(".section__propositos").fadeOut("fast");
      $(".section__propositos-2").fadeOut("fast");
      $(".section__latingrammys").fadeOut("fast");
      $(this).addClass("active");
      $("#propositos-2023").removeClass("active");
      $("#latin-grammys").removeClass("active");
    });

    $("#trigger-roma, #btn-roma-1, #btn-roma-2").on("click", function () {
      $("#card-roma").fadeIn("fast");
      $("#card-dubrovnik").fadeOut();
      $("#card-barcelona").fadeOut();
      $("body").addClass("card-visible");
      $("#card-barcelona iframe").attr(
        "src",
        $("#card-barcelona iframe").attr("src")
      );
      $("#card-dubrovnik iframe").attr(
        "src",
        $("#card-dubrovnik iframe").attr("src")
      );
    });

    $("#trigger-barcelona, #btn-barcelona-1, #btn-barcelona-2").on(
      "click",
      function () {
        $("#card-barcelona").fadeIn("fast");
        $("#card-roma").fadeOut();
        $("#card-dubrovnik").fadeOut();
        $("body").addClass("card-visible");
        $("#card-roma iframe").attr("src", $("#card-roma iframe").attr("src"));
        $("#card-dubrovnik iframe").attr(
          "src",
          $("#card-dubrovnik iframe").attr("src")
        );
      }
    );

    $("#trigger-dubrovnik, #btn-dubrovnik-1, #btn-dubrovnik-2").on(
      "click",
      function () {
        $("#card-dubrovnik").fadeIn("fast");
        $("#card-barcelona").fadeOut();
        $("#card-roma").fadeOut();
        $("body").addClass("card-visible");
        $("#card-barcelona iframe").attr(
          "src",
          $("#card-barcelona iframe").attr("src")
        );
        $("#card-roma iframe").attr("src", $("#card-roma iframe").attr("src"));
      }
    );

    $("#card-roma .card-city__close").click(function () {
      $("#card-roma").fadeOut();
      $("body").removeClass("card-visible");
      $("#card-roma iframe").attr("src", $("#card-roma iframe").attr("src"));
    });

    $("#card-barcelona .card-city__close").click(function () {
      $("#card-barcelona").fadeOut();
      $("body").removeClass("card-visible");
      $("#card-barcelona iframe").attr(
        "src",
        $("#card-barcelona iframe").attr("src")
      );
    });

    $("#card-dubrovnik .card-city__close").click(function () {
      $("#card-dubrovnik").fadeOut();
      $("body").removeClass("card-visible");
      $("#card-dubrovnik iframe").attr(
        "src",
        $("#card-dubrovnik iframe").attr("src")
      );
    });
  });

  /*** Solicitud Matriculas Discover U / Toggle visibility in Next Button */

  $(".form-item-es-cliente-radio #edit-es-cliente-radio-no").change(
    function () {
      if ($(this).is(":checked")) {
        $(".webform-button--next").addClass("radio-checked");
      }
    }
  );

  $(".form-item-es-cliente-radio #edit-es-cliente-radio-si").change(
    function () {
      if ($(this).is(":checked")) {
        $(".webform-button--next").removeClass("radio-checked");
      }
    }
  );
  /**** New Comparator (2024) */

  var count = $(
    "#edit-card-value--wrapper .form-type-checkbox input:checked"
  ).length;
  var $targetElement = $(".section__cards-comparator");
  if ($targetElement.length > 0) {
    var targetOffset = $targetElement.offset().top;
  }

  $(document).on("click", function (event) {
    var fieldset = $("#edit-card-value--wrapper");
    var targetElement = $(event.target);

    if (
      !fieldset.is(targetElement) &&
      fieldset.has(targetElement).length === 0
    ) {
      fieldset.find(".fieldset-wrapper").slideUp("fast");
      fieldset.find("legend").removeClass("expanded");
    }
  });

  $("#edit-card-value--wrapper legend").click(function () {
    $(this).toggleClass("expanded");
    $(
      ".view-cards-comparator-view #edit-card-value--wrapper .fieldset-wrapper"
    ).slideToggle("fast");
  });

  if (count == 0) {
    $("#edit-card-value--wrapper legend").text("Seleccione tarjetas...");
  } else {
    $("#edit-card-value--wrapper legend").text(
      count + " tarjetas seleccionadas"
    );
  }

  $(document).ready(function () {
    $(".faqfield-question").click(function () {
      $(this).toggleClass("clicked");
    });
  });

  /*** Blu Christmas 2024 ****/
  $("#btn-comienza-la-magia").click(function () {
    $(".start-cover").fadeOut("fast");
  });

  /*** Beneficios Gas Club Corporate ****/
  $("#button-autos").click(function () {
    $("#paragraph-id--29466").fadeIn("fast");
    $("#paragraph-id--30739").fadeOut("fast");
    $("#paragraph-id--30742").fadeOut("fast");
    $(this).toggleClass("active");
    $("#button-motocicletas").removeClass("active");
    $("#button-transporte").removeClass("active");
  });

  $("#button-motocicletas").click(function () {
    $("#paragraph-id--30739").fadeIn("fast");
    $("#paragraph-id--29466").fadeOut("fast");
    $("#paragraph-id--30742").fadeOut("fast");
    $(this).toggleClass("active");
    $("#button-autos").removeClass("active");
    $("#button-transporte").removeClass("active");
  });

  $("#button-transporte").click(function () {
    $("#paragraph-id--30742").fadeIn("fast");
    $("#paragraph-id--30739").fadeOut("fast");
    $("#paragraph-id--29466").fadeOut("fast");
    $(this).toggleClass("active");
    $("#button-motocicletas").removeClass("active");
    $("#button-autos").removeClass("active");
  });


  $(document).ready(function () {
        $(".view-display-id-block_9 .card__item:nth-child(2) .card__link.card__link-apply a").text("Solicitar membresía");
  });

  /*** 75 aniversario ****/
  $(document).ready(function () {
    $(".card-front .card-expand").click(function () {
      $('.paragraph--type--carrusel-item .card-back').removeClass("card-back-visible");
      $('.paragraph--type--carrusel-item .card-front').removeClass("card-front-processed");
      $(this).parents('.paragraph--type--carrusel-item').find('.card-front').toggleClass("card-front-processed");
      $(this).parents('.paragraph--type--carrusel-item').find('.card-back').addClass("card-back-visible");
    });
    $(".card-back .card-expand").click(function () {
      $('.paragraph--type--carrusel-item .card-back').removeClass("card-back-visible");
      $('.paragraph--type--carrusel-item .card-front').removeClass("card-front-processed");
    });
  });

  /**** Blu Christmas 2025 ***/
  /*** PLay video on slide focus ***/
  $(document).ready(function() {
      // Función para controlar los videos según el slide activo
      function controlarVideos() {
          // Pausar todos los videos y resetearlos
          $('.slick__slide video').each(function() {
              this.pause();
              this.currentTime = 0;
          });
          
          // Encontrar el slide activo y reproducir su video
          $('.slick__slide.slick-current video').each(function() {
              this.play();
          });
      }
      
      // Ejecutar al cargar la página (por si hay un slide activo inicial)
      controlarVideos();
      
      // Observar cambios en las clases de los slides
      // Usando MutationObserver para detectar cuando se añade/quita la clase 'active'
      var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if (mutation.attributeName === 'class') {
                  controlarVideos();
              }
          });
      });
      
      // Configurar el observer para cada slide
      $('.slick__slide').each(function() {
          observer.observe(this, {
              attributes: true,
              attributeFilter: ['class']
          });
      });
      
  });

  $(document).ready(function() {
    $('.page-blu-christmas-2025-mobile #btn-comienza-magia').click(function () {
      $(this).parents(".slide-introduction").fadeOut();
    });
  });

  /*----------------------------------------
   Cuenta blu: cards "Tu ahorro es blu"
   Al pulsar una card (su .stretched-link la cubre entera) la marca como
   activa (fondo y flecha hacia abajo) y, tras la animación, desplaza
   hasta las preguntas frecuentes.
  ----------------------------------------*/
  Drupal.behaviors.cardsTuAhorroBlu = {
    attach: function (context) {
      once("cards-tu-ahorro", ".card-tu-ahorro .stretched-link", context).forEach(function (link) {
        link.addEventListener("click", function (event) {
          var target = document.getElementById(link.hash.slice(1)) || document.querySelector(".section__tabs");
          if (!target) {
            return;
          }
          event.preventDefault();
          $(link).closest(".card-tu-ahorro").addClass("is-active").siblings(".card-tu-ahorro").removeClass("is-active");
          // data-faq-tab (1, 2, 3…) activa esa pestaña de preguntas frecuentes (faq-tabs.js).
          var tab = document.querySelectorAll(".nav-icons-wrapper .icon-card")[parseInt(link.getAttribute("data-faq-tab"), 10) - 1];
          if (tab) {
            tab.click();
          }
          // Espera a que termine la transición de la card (0.3s) para que se vea el giro de la flecha.
          setTimeout(function () {
            var header = document.querySelector(".header__wrapper");
            var offset = (header ? header.offsetHeight : 0) + 24;
            window.scrollTo({
              top: target.getBoundingClientRect().top + window.pageYOffset - offset,
              behavior: "smooth"
            });
          }, 350);
        });
      });
    }
  };


})(jQuery, Drupal, once);
